<script>
import axios from "axios";

import Layout from "../../layouts/auth";
import {
  authMethods,
  authFackMethods,
  oauth2Methods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";

import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";
import InputPassword from "@/components/inputs/password"

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    InputPassword
  },
  data() {
    return {
      email: process.env.VUE_APP_DEFAULT_AUTH === 'fakebackend' ? "admin@admin.com" : "",
      password: process.env.VUE_APP_DEFAULT_AUTH === 'fakebackend' ? "password" : "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,

      defaultAuth: process.env.VUE_APP_DEFAULT_AUTH,
      oauth2Type: process.env.VUE_APP_OAUTH2_TYPE || 'password'
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
    logoutJalaUrl() {
      return (process.env.VUE_APP_API_BASE_URL || '').replace('/api', '') + '/logout/jala';
    }
  },
  methods: {
    ...authMethods,
    ...(process.env.VUE_APP_DEFAULT_AUTH === "oauth2" ? oauth2Methods : authFackMethods),
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid && (this.defaultAuth !== 'oauth2' || this.oauth2Type === 'password')) {
        return;
      } else {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          this.tryingToLogIn = true;
          // Reset the authError if it existed.
          this.authError = null;
          return (
            this.logIn({
              email: this.email,
              password: this.password,
            })
              // eslint-disable-next-line no-unused-vars
              .then((token) => {
                this.tryingToLogIn = false;
                this.isAuthError = false;
                // Redirect to the originally requested page, or to the home page
                this.$router.push(
                  this.$route.query.redirectFrom || {
                    name: "default",
                  }
                );
              })
              .catch((error) => {
                this.tryingToLogIn = false;
                this.authError = error ? error : "";
                this.isAuthError = true;
              })
          );
        } else if (process.env.VUE_APP_DEFAULT_AUTH === "fakebackend") {
          const { email, password } = this;
          if (email && password) {
            this.login({
              email,
              password,
            });
          }
        } else if (process.env.VUE_APP_DEFAULT_AUTH === "authapi") {
          axios
            .post("http://127.0.0.1:8000/api/login", {
              email: this.email,
              password: this.password,
            })
            .then((res) => {
              return res;
            });
        } else if (process.env.VUE_APP_DEFAULT_AUTH === "oauth2") {
          if (this.oauth2Type !== 'password') {
            const url = new URL(`${process.env.VUE_APP_OAUTH2_BASE_URL}/authorize`);
            const searchParams = new URLSearchParams()
            searchParams.set('client_id', process.env.VUE_APP_OAUTH2_CLIENT_ID);
            searchParams.set('redirect_uri', `${window.location.origin}/login`);
            searchParams.set('response_type', 'token');
            searchParams.set('scope', '*');
            url.search = searchParams.toString();

            const urlLogout = new URL(`${process.env.VUE_APP_API_BASE_URL.replace('/api', '')}/logout`);
            const searchParamsLogout = new URLSearchParams()
            searchParamsLogout.set('redirect', url.toString());
            urlLogout.search = searchParamsLogout.toString();

            const urlLogoutJala = new URL(`${process.env.VUE_APP_STORAGE_JALA_BASE_URL.replace('/storage', '')}/logout`);
            const searchParamsLogoutJala = new URLSearchParams()
            searchParamsLogoutJala.set('redirect', urlLogout.toString());
            urlLogoutJala.search = searchParamsLogoutJala.toString();

            window.location.href = urlLogoutJala.toString();
          } else {
            this.tryingToLogIn = true;
            // Reset the authError if it existed.
            this.authError = null;
            this.isAuthError = false;
            this.oauth2LoginPassword({ username: this.email, password: this.password })
                .then((response) => {
                  this.tryingToLogIn = false;
                  this.isAuthError = false;
                  return response;
                })
                .catch((error) => {
                  this.tryingToLogIn = false;
                  if (error.response && error.response.data && error.response.data.message)
                    this.authError = this.$t(error.response.data.message) || "";
                  else
                    this.authError = error ? error : "";
                  this.isAuthError = true;
                });
          }
        }
      }
    },
  },
  mounted() {
    if (process.env.VUE_APP_DEFAULT_AUTH === 'oauth2') {
      const hash = new URLSearchParams(window.location.hash.replace('#', ''))
      const query = new URLSearchParams(window.location.search.replace('?', ''))
      if (hash.has('access_token')) this.oauth2Login({ accessToken: hash.get('access_token') })
      else if (query.has('code')) this.oauth2LoginCode({ code: query.get('code') })
    }
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft border-bottom">
            <div class="row">
              <div class="col-7">
                <div class="p-4">
                  <h5>{{ lodash.startCase($t('login.welcome')) }}</h5>
                  <p>{{ lodash.upperFirst($t('login.login_to_continue')) }}</p>
                </div>
              </div>
              <div class="col-5 align-self-center">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <!--            <div>-->
            <!--              <router-link tag="a" to="/">-->
            <!--                <div class="avatar-md profile-user-wid mb-4">-->
            <!--                  <span class="avatar-title rounded-circle bg-light">-->
            <!--                    <img src="@/assets/images/logo.svg" alt height="34" />-->
            <!--                  </span>-->
            <!--                </div>-->
            <!--              </router-link>-->
            <!--            </div>-->
            <b-alert
              v-model="isAuthError"
              variant="danger"
              class="mt-3"
              dismissible
              >{{ authError }}</b-alert
            >

            <div
                v-if="!isAuthError && notification.message"
                :class="'mt-3 alert ' + notification.type"
            >
              {{ notification.message }}
            </div>

            <b-form class="p-2" v-if="defaultAuth !== 'oauth2' || oauth2Type === 'password'" @submit.prevent="tryToLogIn">
              <b-form-group
                class="mb-3"
                id="input-group-1"
                label="Email"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="email"
                  type="text"
                  :placeholder="lodash.upperFirst($t('login.email_placeholder'))"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.email.required">Email is required.</span>
                  <span v-if="!$v.email.email">Please enter valid email.</span>
                </div>
              </b-form-group>

              <b-form-group
                class="mb-3"
                id="input-group-2"
                label="Password"
                label-for="input-2"
              >
                <input-password
                    id="input-2"
                    v-model="password"
                    :placeholder="lodash.upperFirst($t('login.password_placeholder'))"
                    :state="!submitted ? null : !$v.password.$error"
                    :class="{ 'is-invalid': submitted && $v.password.$error }"
                ></input-password>
                <div
                  v-if="submitted && !$v.password.required"
                  class="invalid-feedback"
                >
                  Password is required.
                </div>
              </b-form-group>
              <!--              <b-form-checkbox-->
              <!--                  class="form-check"-->
              <!--                  id="customControlInline"-->
              <!--                  name="checkbox-1"-->
              <!--                  value="accepted"-->
              <!--                  unchecked-value="not_accepted"-->
              <!--                >-->
              <!--                  Remember me-->
              <!--                </b-form-checkbox>-->
              <div class="mt-3 d-grid">
                <b-button :disabled="tryingToLogIn" type="submit" variant="primary" class="btn-block"
                >{{ lodash.startCase($t('login.login')) }}</b-button
                >
              </div>
              <!--              <div class="mt-4 text-center">-->
              <!--                <h5 class="font-size-14 mb-3">Sign in with</h5>-->

              <!--                <ul class="list-inline">-->
              <!--                  <li class="list-inline-item">-->
              <!--                    <a-->
              <!--                      href="javascript: void(0);"-->
              <!--                      class="social-list-item bg-primary text-white border-primary"-->
              <!--                    >-->
              <!--                      <i class="mdi mdi-facebook"></i>-->
              <!--                    </a>-->
              <!--                  </li>-->
              <!--                  <li class="list-inline-item">-->
              <!--                    <a-->
              <!--                      href="javascript: void(0);"-->
              <!--                      class="social-list-item bg-info text-white border-info"-->
              <!--                    >-->
              <!--                      <i class="mdi mdi-twitter"></i>-->
              <!--                    </a>-->
              <!--                  </li>-->
              <!--                  <li class="list-inline-item">-->
              <!--                    <a-->
              <!--                      href="javascript: void(0);"-->
              <!--                      class="social-list-item bg-danger text-white border-danger"-->
              <!--                    >-->
              <!--                      <i class="mdi mdi-google"></i>-->
              <!--                    </a>-->
              <!--                  </li>-->
              <!--                </ul>-->
              <!--              </div>-->
<!--              <div class="mt-4 text-center">-->
<!--                <router-link tag="a" to="/password/email" class="text-muted">-->
<!--                  <i class="mdi mdi-lock me-1"></i> {{ lodash.startCase($t('login.forgot_password')) }}-->
<!--                </router-link>-->
<!--              </div>-->
            </b-form>
            <b-form class="p-2" v-else @submit.prevent="tryToLogIn">
              <div class="mt-3 d-grid">
                <b-button :disabled="tryingToLogIn" type="submit" variant="primary" class="btn-block"
                >{{ lodash.upperFirst($t('login.login_by_something', { something: 'JALA' })) }}</b-button
                >
              </div>
<!--              <div class="mt-2 d-grid">-->
<!--                <b-button :disabled="tryingToLogIn" variant="link" :href="logoutJalaUrl" class="btn-block" target="_blank"-->
<!--                >{{ lodash.upperFirst($t('login.open_something', { something: 'JALA' })) }}</b-button-->
<!--                >-->
<!--              </div>-->
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
<!--          <p>-->
<!--            Don't have an account ?-->
<!--            <router-link-->
<!--              tag="a"-->
<!--              to="/register"-->
<!--              class="fw-medium text-primary"-->
<!--              >Signup now</router-link-->
<!--            >-->
<!--          </p>-->
          <p>
            © {{ new Date().getFullYear() }} JALA
          </p>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
